import { useEffect, useRef, useState } from "react";
import { CheckCircle2, PlayCircle, Clock, Video, Award } from "lucide-react";
import { JOURNEY } from "./data";

function PreviewBody({ kind }) {
  if (kind === "opportunities") {
    return (
      <div>
        <div className="flex items-center justify-between mb-3">
          <div className="text-xs font-semibold text-slate-700">فرص منشورة</div>
          <div className="text-[10px] text-teal-700 font-bold">4 نتائج</div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          {["التسويق الرقمي", "تطوير الويب", "المحاسبة", "إدارة مشاريع"].map((c, i) => (
            <div key={i} className="rounded-xl border border-cream-200 overflow-hidden">
              <div className="h-16 bg-gradient-to-br from-teal-700 to-teal-900">
                <div className="p-1.5">
                  <span className="text-[8px] font-bold bg-white/95 text-teal-800 px-1.5 py-0.5 rounded-full">{c}</span>
                </div>
              </div>
              <div className="p-2">
                <div className="h-1.5 rounded bg-cream-200 w-3/4" />
                <div className="mt-1 h-1.5 rounded bg-cream-200 w-1/2" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
  if (kind === "application") {
    return (
      <div>
        <div className="text-xs font-semibold text-slate-700 mb-3">حالة الطلب</div>
        <div className="space-y-2">
          {[
            { k: "قيد المراجعة", ok: true },
            { k: "مقبول", ok: true },
            { k: "تم التسكين داخل منظمة", ok: false },
          ].map((s, i) => (
            <div key={i} className={`flex items-center gap-2 p-2 rounded-lg border text-xs ${s.ok ? "bg-emerald-50 border-emerald-100 text-emerald-800" : "bg-cream-50 border-cream-200 text-slate-500"}`}>
              {s.ok ? <CheckCircle2 className="h-3.5 w-3.5" /> : <Clock className="h-3.5 w-3.5" />}
              <span>{s.k}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
  if (kind === "learning") {
    return (
      <div>
        <div className="rounded-xl bg-slate-950 aspect-video grid place-items-center relative overflow-hidden">
          <PlayCircle className="h-12 w-12 text-white/90 relative z-10" />
          <div className="absolute inset-x-0 bottom-0 h-1.5 bg-white/10">
            <div className="h-full bg-amber-400" style={{ width: "62%" }} />
          </div>
        </div>
        <div className="mt-3 flex items-center justify-between text-xs">
          <div>
            <div className="font-semibold text-slate-900">الوحدة 3: تحليل جدوى</div>
            <div className="text-[10px] text-slate-500">مقرر أساسيات المحاسبة</div>
          </div>
          <span className="text-teal-700 font-bold arabic-numerals">62%</span>
        </div>
      </div>
    );
  }
  if (kind === "tasks") {
    return (
      <div>
        <div className="flex items-center justify-between mb-3">
          <div className="text-xs font-semibold text-slate-700">مهامي</div>
          <span className="text-[10px] text-amber-700 bg-amber-50 border border-amber-100 px-1.5 py-0.5 rounded-full">3 مفتوحة</span>
        </div>
        <div className="space-y-2">
          {[
            { t: "تحليل حالة عميل — مستشفى", s: "مقيّمة", tone: "emerald" },
            { t: "تسليم أسبوعي — التقرير الثاني", s: "مُرسلة", tone: "sky" },
            { t: "خطة تسويق أولية", s: "مفتوحة", tone: "amber" },
          ].map((t, i) => (
            <div key={i} className="flex items-center justify-between p-2.5 rounded-lg border border-cream-200 bg-cream-50/50 text-xs">
              <span className="text-slate-800 truncate">{t.t}</span>
              <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full shrink-0 ms-2 ${
                t.tone === "emerald" ? "bg-emerald-50 text-emerald-700"
                : t.tone === "sky" ? "bg-sky-50 text-sky-700"
                : "bg-amber-50 text-amber-700"
              }`}>{t.s}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
  if (kind === "sessions") {
    return (
      <div>
        <div className="text-xs font-semibold text-slate-700 mb-3">جلساتي</div>
        <div className="rounded-xl p-4 bg-gradient-to-br from-teal-700 to-teal-900 text-white">
          <div className="flex items-center justify-between">
            <div className="text-xs text-teal-100">الجلسة القادمة</div>
            <Video className="h-4 w-4 text-teal-100" />
          </div>
          <div className="mt-1 font-heading font-bold">متابعة الأسبوع الثالث</div>
          <div className="mt-2 flex items-center gap-3 text-xs text-teal-100">
            <span className="inline-flex items-center gap-1 arabic-numerals">
              <Clock className="h-3 w-3" /> خلال 20 ساعة
            </span>
            <span className="arabic-numerals">45 دقيقة</span>
          </div>
        </div>
        <div className="mt-3 p-2.5 rounded-lg bg-cream-50 border border-cream-200 text-xs text-slate-600">
          آخر جلسة: <span className="font-semibold text-slate-800">تم توثيق الملاحظات</span>
        </div>
      </div>
    );
  }
  if (kind === "impact") {
    return (
      <div>
        <div className="text-xs font-semibold text-slate-700 mb-3">تقرير الأثر — مارس</div>
        <div className="grid grid-cols-3 gap-2">
          {[
            { k: "ساعات", v: "48", tone: "text-teal-700" },
            { k: "مهام", v: "12", tone: "text-amber-600" },
            { k: "جلسات", v: "6", tone: "text-emerald-600" },
          ].map((it, i) => (
            <div key={i} className="p-3 rounded-xl border border-cream-200 text-center bg-cream-50/50">
              <div className={`text-2xl font-heading font-black arabic-numerals ${it.tone}`}>{it.v}</div>
              <div className="text-[10px] text-slate-500 mt-1">{it.k}</div>
            </div>
          ))}
        </div>
        <div className="mt-3">
          <div className="text-[10px] text-slate-500 mb-1 flex items-center justify-between">
            <span>تقدّم البرنامج</span><span className="arabic-numerals text-teal-700 font-bold">78%</span>
          </div>
          <div className="h-1.5 bg-cream-100 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-l from-amber-400 to-teal-600" style={{ width: "78%" }} />
          </div>
        </div>
      </div>
    );
  }
  // certificate
  return (
    <div className="relative p-4 rounded-2xl bg-gradient-to-br from-teal-800 to-slate-950 text-white overflow-hidden">
      <div className="absolute -top-8 -end-8 h-24 w-24 rounded-full bg-amber-400/20 blur-2xl" />
      <div className="relative">
        <div className="flex items-center justify-between">
          <div className="text-[10px] font-bold text-amber-300 uppercase tracking-widest">شهادة إتمام</div>
          <Award className="h-5 w-5 text-amber-300" />
        </div>
        <div className="mt-2 font-heading font-black text-lg">شهادة إتمام موثّقة</div>
        <div className="mt-3 text-xs text-teal-100">فرصة تدريب تعاوني — بيانات تجريبية</div>
        <div className="mt-4 flex items-center justify-between">
          <span className="text-[10px] font-mono text-teal-200" dir="ltr">EMAD-XXXX-YYYY</span>
          <div className="h-10 w-10 grid place-items-center bg-white rounded-md">
            <div className="h-8 w-8 bg-[repeating-linear-gradient(45deg,#0f172a_0_2px,transparent_2px_4px)]" />
          </div>
        </div>
      </div>
    </div>
  );
}

function JourneyPreview({ stage, compact }) {
  return (
    <div
      className={`relative rounded-3xl border border-cream-200 bg-white overflow-hidden card-shadow-lg ${compact ? "" : "aspect-[4/3]"}`}
      data-testid="journey-preview"
      aria-live="polite"
    >
      <div className="flex items-center gap-2 px-5 py-3 bg-cream-100/80 border-b border-cream-200">
        <span className="h-2.5 w-2.5 rounded-full bg-rose-400" />
        <span className="h-2.5 w-2.5 rounded-full bg-amber-400" />
        <span className="h-2.5 w-2.5 rounded-full bg-teal-500" />
        <div className="ms-3 text-[11px] text-slate-500 font-mono">emad.sa / {stage.preview}</div>
      </div>
      <div className="p-4 lg:p-7">
        <div
          key={stage.id}
          className="animate-[fadeInUp_0.4s_ease-out]"
          style={{ animation: "journeyFadeUp 0.45s ease-out both" }}
        >
          <PreviewBody kind={stage.preview} />
        </div>
      </div>
    </div>
  );
}

export default function JourneySection() {
  const [active, setActive] = useState(0);
  const refs = useRef([]);

  useEffect(() => {
    let ticking = false;
    const compute = () => {
      // Anchor: matches the sticky card's top edge (top-24 = 96px) + small buffer
      const anchor = 180;
      let idx = 0;
      refs.current.forEach((el, i) => {
        if (!el) return;
        const rect = el.getBoundingClientRect();
        // Active = last stage whose top has crossed the anchor line
        if (rect.top - anchor <= 0) {
          idx = i;
        }
      });
      setActive(idx);
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(compute);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    compute();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <section id="journey" className="relative py-20 lg:py-28 bg-cream-50" data-testid="journey-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14 lg:mb-20">
          <div className="text-xs font-bold uppercase tracking-widest text-teal-700">رحلة الأثر المجتمعي</div>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-heading font-black text-slate-900 leading-tight">
            مراحل عماد — من فرصة تدريب تعاوني إلى أثر مستدام
          </h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="hidden lg:block lg:col-span-6">
            <div className="sticky top-24">
              <JourneyPreview stage={JOURNEY[active]} />
            </div>
          </div>

          <div className="lg:col-span-6 relative">
            <div className="hidden lg:block absolute top-2 bottom-2 start-4 w-0.5 bg-cream-200 rounded-full" aria-hidden="true">
              <div
                className="w-full bg-gradient-to-b from-amber-400 via-rose-400 to-teal-600 rounded-full transition-all duration-500"
                style={{ height: `${((active + 1) / JOURNEY.length) * 100}%` }}
              />
            </div>

            <ol className="space-y-16 lg:space-y-24">
              {JOURNEY.map((s, i) => {
                const Icon = s.icon;
                const isActive = i === active;
                return (
                  <li
                    key={s.id}
                    ref={(el) => (refs.current[i] = el)}
                    data-idx={i}
                    data-testid={`journey-stage-${i + 1}`}
                    className="relative ps-0 lg:ps-16"
                  >
                    <div
                      className={`hidden lg:grid absolute top-2 start-0 h-9 w-9 rounded-full place-items-center border-4 transition-all ${
                        isActive
                          ? "bg-teal-700 border-teal-100 text-white scale-110"
                          : i < active
                          ? "bg-emerald-500 border-emerald-100 text-white"
                          : "bg-white border-cream-200 text-slate-400"
                      }`}
                    >
                      {i < active ? <CheckCircle2 className="h-4 w-4" /> : <Icon className="h-4 w-4" strokeWidth={2} />}
                    </div>

                    <div className="lg:hidden mb-4">
                      <JourneyPreview stage={s} compact />
                    </div>

                    <div className={`transition-opacity ${isActive ? "opacity-100" : "opacity-70"}`}>
                      <div className="text-xs font-bold uppercase tracking-widest text-amber-600">{s.tag}</div>
                      <h3 className="mt-2 text-2xl lg:text-2xl font-heading font-black text-slate-900 leading-tight">
                        {s.title}
                      </h3>
                      <p className="mt-4 text-slate-700 text-base lg:text-lg leading-relaxed max-w-lg">
                        {s.body}
                      </p>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
